/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SendChatSideEffectsRequest} from '@cash-web/protos/squareup/cash/supportal/service.pb'
import {SendChatSideEffectsResponse} from '@cash-web/protos/squareup/cash/supportal/service.pb'


export const sendChatSideEffects = (request:SendChatSideEffectsRequest, options?: CashRequestOptions) => post<SendChatSideEffectsRequest, SendChatSideEffectsResponse>("/2.0/cash/send-chat-side-effects", request, {...options, rejectOnError: true })